<template>
<div class="chapter">
<div class="inner_page">
<div class="dedication" id="ded">
<p class="nonindent"><em>Patricia, eres la lluvia en mi desierto.</em><br/><em>                 I give you this book—every word—for you.</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780062045980_epub_ded_r1.vue?12ee7ed4